// A trigger + popover list for the ticket window (assign, topic, client,
// EDN status, attachments). Same skin as the « ⋯ » OverflowMenu of
// src/design/ui.js (.u-menu / .u-menu__item), but the trigger is any button
// (a chip, a badge, a labelled secondary button) and the content is free
// (a heading, a search field, rows with a check). Escape and a click outside
// close it. Proposal for ui.css: a « Popover » sibling of OverflowMenu.
import React, { useEffect, useRef, useState } from 'react';

const cx = (...names) => names.filter(Boolean).join(' ');

const TicketWorkspaceMenu = ({
    trigger,
    triggerClassName = 'u-btn u-btn--secondary u-btn--sm',
    triggerTitle,
    triggerLabel,
    triggerTour,
    disabled,
    align = 'right',
    heading,
    className,
    panelClassName,
    onOpen,
    children,
}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onDown = (event) => { if (ref.current && !ref.current.contains(event.target)) setOpen(false); };
        const onKey = (event) => { if (event.key === 'Escape') setOpen(false); };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);

    const close = () => setOpen(false);

    return (
        <div className={cx('u-menu-anchor tkw-menu', className)} ref={ref}>
            <button
                type="button"
                className={triggerClassName}
                aria-haspopup="menu"
                aria-expanded={open}
                aria-label={triggerLabel}
                title={triggerTitle}
                data-tour={triggerTour}
                disabled={disabled}
                onClick={() => {
                    if (!open && onOpen) onOpen();
                    setOpen((value) => !value);
                }}
            >
                {trigger}
            </button>
            {open && (
                <div className={cx('u-menu tkw-menu__panel', align === 'left' && 'tkw-menu__panel--left', panelClassName)} role="menu">
                    {heading && <div className="tkw-menu__heading">{heading}</div>}
                    {typeof children === 'function' ? children(close) : children}
                </div>
            )}
        </div>
    );
};

export default TicketWorkspaceMenu;
